module.exports = __webpack_public_path__ + "img/user.47305402.png";